import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import ApiEnter from "@/api/ApiEnter";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import sweetalert from "sweetalert";
import DataDiscountCodes from "@/data/AdminPanel/DataDiscountCodes";
import CKEditorConfig from "@/data/CKeditor/config";
import dayjs from "dayjs";
import ApiShopDiscountCodes from "@/api/ApiShopDiscountCodes";
import ApiOffer from "@/api/ApiOffer";
let DiscountCodesCreate = class DiscountCodesCreate extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.Breadcrumbs = DataDiscountCodes.BreadcrumbsCreate;
        this.editorConfig = CKEditorConfig.editorConfig(ApiEnter.CurrentSessionUUID);
        this.newOption = {
            name: "",
            active: true,
            expires_at: null,
            actions: [
                { discount_type: 0, amount: "", amount_type: 1, enabled: false, params: [] },
                { discount_type: 1, amount: "", amount_type: 1, enabled: false, params: [] },
                { discount_type: 2, amount: "", amount_type: 1, enabled: false, params: [] },
                { discount_type: 3, amount: "", amount_type: 1, enabled: false, params: [] },
                { discount_type: 4, amount: "100", amount_type: 1, enabled: false, params: [] }
            ],
            only_mnp: false,
            send_to_bss: false,
            dont_send_to_logistic: false,
            nexi_tokenization: false
        };
        this.HasLoading = false;
        this.isOpenDate = false;
        this.ShopOptions = [];
        this.AmountTypes = [
            { name: "Euro", value: 0 },
            { name: "Percent", value: 1 }
        ];
        this.SupportDiscountTypes = [
            { name: "Delivery in E-Shop", value: 0 },
            { name: "eSIM price new activation", value: 1 },
            { name: "eSIM price new activation with MNP", value: 2 }
        ];
    }
    get AvailableShopOptions() {
        const usedOptions = this.newOption.actions[1].params.map(String);
        if (!this.ShopOptions) {
            return [];
        }
        return this.ShopOptions.filter(el => el.external_id).filter(el => !usedOptions.includes(String(el.external_id)));
    }
    get AvailableSupportDiscountTypes() {
        const usedType = this.newOption.actions[2].params.map(String);
        return this.SupportDiscountTypes?.filter(el => !usedType.includes(String(el.value)));
    }
    get computedDateFormatted() {
        if (!this.newOption.expires_at) {
            return "";
        }
        return dayjs.tz(this.newOption.expires_at, "Europe/Rome").format("DD-MM-YYYY");
    }
    get cantSubmit() {
        const noActions = (!this.newOption.actions[0].enabled &&
            !this.newOption.actions[1].enabled &&
            !this.newOption.actions[2].enabled &&
            !this.newOption.actions[3].enabled &&
            !this.newOption.actions[4].enabled);
        const noAmountInAction = ((this.newOption.actions[0].enabled && !this.newOption.actions[0].amount) ||
            (this.newOption.actions[1].enabled && !this.newOption.actions[1].amount) ||
            (this.newOption.actions[2].enabled && !this.newOption.actions[2].amount) ||
            (this.newOption.actions[3].enabled && !this.newOption.actions[3].amount));
        const noOptionsParams = (this.newOption.actions[1].enabled && !this.newOption.actions[1].params.length);
        const noSupportParams = (this.newOption.actions[2].enabled && !this.newOption.actions[2].params.length);
        return (!this.newOption.name ||
            noActions ||
            noAmountInAction ||
            noOptionsParams ||
            noSupportParams);
    }
    discountCodeNameValidator() {
        if (this.newOption) {
            this.newOption.name = this.newOption.name.replace(/[^A-Z0-9]/gi, "").toUpperCase();
        }
    }
    amountValidator(index) {
        if (this.newOption) {
            const parsedAmount = parseFloat(this.newOption.actions[index].amount);
            if ((this.newOption.actions[index].amount_type == 1) && (parsedAmount > 100)) {
                this.newOption.actions[index].amount = "100";
            }
            else if (parsedAmount < 1) {
                this.newOption.actions[index].amount = "1";
            }
            else {
                this.newOption.actions[index].amount = this.newOption.actions[index].amount.replace(/[^0-9 .,]/g, "");
            }
        }
    }
    allowedDates(value) {
        const today = new Date();
        const selected = new Date(value);
        return today < selected;
    }
    onFreeShipmentEnabled() {
        if (this.newOption.actions[4]) {
            this.newOption.actions[0].enabled = false;
            this.newOption.actions[1].enabled = false;
            this.newOption.actions[2].enabled = false;
            this.newOption.actions[3].enabled = false;
        }
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            const discountCodeUUID = await ApiShopDiscountCodes.CreateDiscountCode(ApiEnter.CurrentSessionUUID, this.newOption.name, this.newOption.active, this.newOption.expires_at, this.newOption.actions.filter(el => el.enabled), this.newOption.only_mnp, this.newOption.send_to_bss, this.newOption.actions[4].enabled ? (this.newOption.dont_send_to_logistic) : false, this.newOption.nexi_tokenization);
            if (discountCodeUUID == undefined || discountCodeUUID.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: "Discount code name should be unique.",
                    icon: "info"
                });
                this.HasLoading = false;
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success"
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/shop/discount-codes`);
            });
        }
        this.HasLoading = false;
    }
    async GetShopOptions() {
        try {
            const offers = await ApiOffer.GetOffers(ApiEnter.CurrentSessionUUID);
            if (typeof offers === "boolean") {
                return;
            }
            this.ShopOptions = offers || [];
        }
        catch (e) {
            console.error(e);
        }
    }
    mounted() {
        this.GetShopOptions();
    }
};
DiscountCodesCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader, CKEditor }
    })
], DiscountCodesCreate);
export default DiscountCodesCreate;
